
<h1 mat-dialog-title>Izaberite opciju za slanja fakture</h1>

<div class="button-wrapper row">
    <button type="button" class="btn custom-button" (click)="onNoClick()"
    >
    <mat-icon>close</mat-icon>
    Odustani
    </button>

    <div *ngIf="invoiceData?.sendEmail==true && invoiceData?.statusName=='Draft' &&  invoiceData?.currency=='RSD' ">
        <mat-button-toggle-group>
            <mat-button-toggle class="split-button-1" (click)="toggleButton()"><mat-icon>send</mat-icon> {{ buttonLabel }}</mat-button-toggle>
            <mat-button-toggle class="drop-down-button" [matMenuTriggerFor]="menu">
            <mat-icon>arrow_drop_down</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>

            <mat-menu #menu="matMenu" xPosition="before">
                <button *ngIf="deliveryMetod !==1" (click)="onSelect(1);" mat-menu-item>
                    POSLATI NA EFAKTURE
                </button>
                <button *ngIf="deliveryMetod !==2" (click)="onSelect(2);" mat-menu-item>
                    POSLATI NA EFAKTURE I EMAIL
                </button>
                <button  *ngIf="deliveryMetod !==3" (click)="onSelect(3);" mat-menu-item>
                    POSLATI NA EMAIL
                </button>
            </mat-menu>
    </div>   
</div>